import * as Models from "./";

export interface IBaseIssue {
  issueId: number;
  submissionDate: Date;
  dueDate: Date;
  type: IssueType;
  assignedUserId: string;
  assignedTeamId: string;
  status: IssueStatus;
  title: string;
  priority: Priority;
  shortDescription: string;
  customerName?: string;
  partnerCustomerNumber?: string;
  serviceAddressStr: string;
}

export interface IIssue extends IBaseIssue {
  submissionUser: string;
  submissionUserId: string;
  completionDate: string;
  description: string;
  relateId?: string;
  igsCustomerNumber: string;
  lastToClose: boolean;
  notifyOnClose: boolean;
}

export class Issue implements IIssue {
  public issueId: number;
  public submissionDate: Date;
  public submissionUser: string;
  public submissionUserId: string;
  public completionDate: string;
  public customerName?: string;
  public partnerCustomerNumber?: string;
  public dueDate: Date;
  public type: IssueType;
  public assignedUserId: string;
  public assignedTeamId: string;
  public description: string;
  public status: IssueStatus;
  public title: string;
  public priority: Priority;
  public relateId?: string;
  public igsCustomerNumber: string;
  public lastToClose: boolean;
  public notifyOnClose: boolean;
  public shortDescription: string;
  public partner: Models.PartnerModel.PartnerModel;
  public serviceAddressStr: string;

  constructor(customerName?: string, partnerCustomerNumber?: string, igsCustomerNumber?: string) {
    this.customerName = customerName;
    this.partnerCustomerNumber = partnerCustomerNumber;
    this.igsCustomerNumber = igsCustomerNumber;
  }
}

export interface IIssueResponse {
  issue: IIssue;
  commentCount: number;
  historyItemCount: number;
  documentCount: number;
}

export interface IIssueCommentModel {
  comments: Comment[];
  hasLoaded: boolean;
}

export class IssueCommentModel implements IIssueCommentModel {
  public comments: Comment[];
  public hasLoaded: boolean;
}

export interface IIssueHistoryModel {
  history: History[];
  hasLoaded: boolean;
}

export class IssueHistoryModel implements IIssueHistoryModel {
  public history: History[];
  public hasLoaded: boolean;
}

export interface IIssueStatus {
  name: string;
  code: string;
  issueStatusId: number;
}

export class IssueStatus implements IIssueStatus {
  public name: string;
  public code: string;
  public issueStatusId: number;
}

export interface IPriority {
  name: string;
  code: string;
  priorityId: number;
}

export class Priority implements IPriority {
  public name: string;
  public code: string;
  public priorityId: number;
}

export interface IIssueType {
  name: string;
  code: string;
  relatedTo: string;
  issueTypeId: number;
}

export class IssueType implements IIssueType {
  public name: string;
  public code: string;
  relatedTo: string;
  public issueTypeId: number;
}

export interface IIssuePriority {
  name: string;
  code: string;
  priorityId: number;
}

export class IssuePriority implements IIssuePriority {
  public name: string;
  public code: string;
  public priorityId: number;
}

export class IssueHistoryEvent {
  public title: string;
  public date: string;
  public description: string;
}

export interface IComment {
  commentId: number;
  issueId: number;
  createDate: Date;
  creatorName?: string;
  description: string;
}

export class Comment implements IComment {
  public commentId: number;
  public issueId: number;
  public createDate: Date;
  public creatorName?: string;
  public description: string;
}

export interface ITeam {
  groupId: string;
  name: string;
  isUserTeam: boolean;
  isPartnerTeam: boolean;
}

export class Team implements ITeam {
  public groupId: string;
  public name: string;
  public isUserTeam: boolean;
  public isPartnerTeam: boolean;
}

export interface IUser {
  agentCode: string;
  comment: string;
  displayName: string;
  emailAddress: string;
  groups: Team[];
  isApproved: boolean;
  isBrokerAgent: boolean;
  isLocked: boolean;
  partner: Partner;
  password: string;
  roles: Role[];
  solicitorNumber: string;
  userId: string;
  username: string;
  windowsUsername: string;
}

export class User implements IUser {
  public agentCode: string;
  public comment: string;
  public displayName: string;
  public emailAddress: string;
  public groups: Team[];
  public isApproved: boolean;
  public isBrokerAgent: boolean;
  public isLocked: boolean;
  public partner: Partner;
  public password: string;
  public roles: Role[];
  public solicitorNumber: string;
  public userId: string;
  public username: string;
  public windowsUsername: string;
}

export interface IRole {
  roleId: string;
  name: string;
  groups: Team[];
  description: string;
}

export class Role implements IRole {
  public roleId: string;
  public name: string;
  public groups: Team[];
  public description: string;
}

export interface IPartner {
  code: string;
  groups: Team[];
  name: string;
  partnerSettings: any;
  users: User[];
}

export class Partner implements IPartner {
  public code: string;
  public groups: Team[];
  public name: string;
  public partnerSettings: any;
  public users: User[];
}

export interface IHistory {
  type: string;
  eventDate: Date;
  previousValue: string;
  newValue: string;
  createDate: Date;
  createBy: string;
}

export class History implements IHistory {
  public type: string;
  public eventDate: Date;
  public previousValue: string;
  public newValue: string;
  public createDate: Date;
  public createBy: string;
}

export interface ISearchWorkIssuesRequest {
  includeClosed: boolean;
  onlyMine: boolean;
  showUnassigned: boolean;
  type: string;
  status: string;
  assignedToUser: string;
  assignedToTeam: string;
  partner: string;
  searchTerm: string;
  skip: number;
  take: number;
  igsCustomerNumber?: string;
  partnerSystemNumber?: string;
  orderBy?: string;
  IncludePreviouslyOwned: boolean;
}

export class SearchWorkIssuesRequest implements ISearchWorkIssuesRequest {
  searchTerm: string;
  type: string;
  status: string;
  assignedToUser: string;
  assignedToTeam: string;
  partner: string;
  orderBy? = "";
  includeClosed = false;
  IncludePreviouslyOwned = false;
  onlyMine = false;
  showUnassigned = false;
  skip = 0;
  take = 25;
  igsCustomerNumber?: string;
  partnerSystemNumber?: string;
  constructor(take?: number) {
    if (take) {
      this.take = take;
    }
  }
}
